// extracted by mini-css-extract-plugin
export var scrollArea = "_pp-0";